export const unifyEvent = (e) => ({
    eventId: e.id,
    eventScore: e.eventScore,
    liveGameState: e.liveGameState,
    isLive: e.isLive
});
//# sourceMappingURL=unifyEvent.js.map